import React from 'react';
import { motion } from "framer-motion";
import { Link } from 'react-router-dom';

import about_4 from "../../../assets/images/about/about-4.jpg";
import about_5 from "../../../assets/images/about/about-5.jpg";
import pic_1 from "../../../assets/images/Bytelingo.jpg";
import pic_2 from "../../../assets/images/meridian_law.jpg";

import Members from '../../../assets/icons/members';
import Technology from '../../../assets/icons/technology';
import { slideUp } from '../../../utils/slideUp';


const AboutOne = () => {
  return (
    <section style={{ padding: '75px 20px' }} className="about-area style-2 pb-75">
      <div className="container">
        <motion.div className="row align-items-center"
          initial="offscreen"
          whileInView="onscreen"
          variants={ slideUp() }
          viewport={{ once: true, amount: 0.4 }}
        >

          <div className="col-lg-6">
            <div className="about-image style-2">
              <div className="image-1">
                <img src={ pic_1 } alt="about-image" />
              </div>
              <div className="image-two">
                <img src={ pic_2 } alt="about-image" />
              </div>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="about-content style-2">
              <div className="title">
                <span className="d-block">DraftLegal AI</span>
                <h2>AI 時代的法律諮詢</h2>
                <p>能夠幫你編寫法律合約的 AI？再也不是天方夜譚。</p>
                <p>經兆國際法律事務所將設立超過 20 年來的專業台灣法律知識導入生成式 AI，首創熟悉台灣法律合約內容細節的 AI 法律助手。</p>
              </div>
              <div className="content-card d-flex align-items-center">
                <div className="icon">
                  <Members />
                </div>
                <div className="content">
                  <h3>法律專業性毋庸置疑</h3>
                  <p>經兆成立 20 年來，處理國內外跨境事務、資本金融、智慧財產、爭端處理等訴、非訟業務，近 40 名律師竭誠為您服務。</p>
                </div>
              </div>
              <div className="content-card d-flex align-items-center">
                <div className="icon">
                  <Technology />
                </div>
                <div className="content">
                  <h3>尖端 AI 技術打造新世代法律服務樣貌</h3>
                  <p>經兆攜手台灣生成式 AI 企業導入之領導者賦語科技團隊，借重其導入百家上市櫃企業之先進 AI 技術與豐富知能，打造先進法律服務模式</p>
                </div>
              </div>

              {/* Link Buttons */}
              <div className="responsive-buttons" style={{ display: 'flex', flexWrap: 'wrap' }}>
                <div className="button-wrapper" style={{ marginRight: '1rem', marginBottom: '1rem' }}>
                  <a className="default-btn text-decoration-none" href="http://www.law-meridian.com/" target="_blank" rel="noopener noreferrer">
                    <i className="ri-arrow-right-line"></i>
                    瞭解經兆法律事務所
                  </a>
                </div>
                <div>
                  <a className="default-btn text-decoration-none" href="https://bytelingo.co" target="_blank" rel="noopener noreferrer">
                    <i className="ri-arrow-right-line"></i>
                    瞭解賦語科技
                  </a>
                </div>
              </div>

            </div>
          </div>


        </motion.div>
      </div>
    </section>
  )
}

export default AboutOne;


